import { put, call, getContext } from "redux-saga/effects";

import { claimDoc } from "../../Services/ClaimCashless";

export function* claimDocSaga(action) {
  const store = yield getContext("store");

  const { payload } = action;
  try {
    const res = yield call(claimDoc, payload);

    yield put({ type: "REQ_CLAIM_DOC_SUCCESS", data: res.data });
  } catch (e) {
    yield put({ type: "REQ_CLAIM_DOC_FAILED", errData: e });
  }
}
